
<template>
  <div class="container column row_cent">
    <div class="relative martch_width" style="height: 30px">
      <img src="../../assets/back.png" alt="" class="back" @click="back" />
      <span class="title">立即提现</span>
    </div>

    <div class="content row row_cent" style="margin-top: 10px">
      <img src="../../assets/ic_zfb.png" alt="" class="zfb" />
      <span class="txzfb">提现到支付宝</span>
      <div class="row right row_cent" @click="toBind">
        <span class="unbindtxt">{{withdrawInfo?'已绑定支付宝':'您还未绑定支付宝'}}</span>
        <img src="../../assets/arrow_right.png" alt="" class="arrowright" />
      </div>
    </div>
    <div class="content column" style="margin-top: 10px">
      <span class="t2">提现金额</span>
      <div class="row relative row_cent">
        <span class="t3">¥</span>
        <van-field
          v-model="money"
          type="number"
          :formatter="formatter"
          :placeholder="'最高可提现'+balance+'元'"
          :rules="[{ required: true, message: '请输入金额' }]"
        ></van-field>
        <span class="right t4" @click="myAll">全部</span>
      </div>
      <div class="line"></div>

      <div class="t5">提现金额需大于1元</div>
    </div>


    <div class="tips" >注：提现手续费6.5% &nbsp;&nbsp;&nbsp;{{ about }}</div>

    <div class="btn" style="margin-top: 16px">
      <van-button
        block
        type="info"
        native-type="submit"
        @click="tryCash"
        >确认提现</van-button
      >
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";

export default {
  data() {
    return {
      money: undefined,
      withdrawInfo: {},
      balance:this.$store.state.balance,
      // balance:100,
      about:""
    };
  },
  mounted() {
    this.onload();
  },
  methods: {
    onload() {
      this.$request.GET({
        url:'agent/withdrawal',
        success:(obj)=>{
            this.withdrawInfo = obj;
        }
      })
    },

    formatter(value) {
      // 过滤输入的数字
      let money = value>this.balance?this.balance:value;
      if(money>=1){
        this.about = `预计到账${(money*(1-0.065)).toFixed(2)}元`
      }else{
        this.about = ""
      }
      return money;
    },
  
    tryCash() {
      if (this.money && this.money > 0) {
        this.$request.POST({
          url: "agent/withdrawal/log",
          data: {rmb: this.money },
          success: (obj) => {
            Toast("申请提现成功");
            this.loadAccount();
            this.money = undefined;
          },
        });
      }else{
        Toast({
          message:"请输入提现金额"
        })
      }
    },
    loadAccount(){
      this.$request.GET({
        url:'agent/account',
        success:(obj)=>{
          this.$store.commit('setBalance',obj.balance)
        }
      })
    },
    myAll() {
      this.money = this.balance;
    },
    back() {
      this.$router.back();
    },
    toBind() {
      this.$router.push({ name: "bindzfb" });
    },
  },
};
</script>

<style scoped>
.container {
  height: 100%;
  padding-top: 20px;
  padding-left: 10px;
  padding-right: 10px;
  background: #f2f2f2;
}

.tips {
  width: 100%;
  margin-left: 20px;
  text-align: left;
  font-size: 12px;
  color: red;
}

.martch_width {
  width: 100%;
}
.relative {
  position: relative;
}
.column {
  display: flex;
  flex-direction: column;
}
.column_cent {
  justify-content: center;
}
.row_cent {
  align-items: center;
}
.row {
  display: flex;
  flex-direction: row;
}

.back {
  position: absolute;
  left: 10px;
  width: 10px;
  height: 16px;
  top: 0;
  bottom: 0;
  margin: auto;
  z-index: 3;
}
.title {
  position: absolute;
  left: 0;
  right: 0;
  color: black;
  font-size: 17px;
  top: 0;
  bottom: 0;
  margin: auto;
  line-height: 30px;
}
.content {
  width: 100%;
  background-color: white;
  border-radius: 6px;
  min-height: 50px;
  position: relative;
}

.zfb {
  width: 25px;
  height: 25px;
  margin-left: 10px;
}
.txzfb {
  font-size: 14px;
  color: black;
  margin-left: 10px;
}
.right {
  position: absolute;
  right: 10px;
  top: 0;
  bottom: 0;
}
.unbindtxt {
  font-size: 12px;
  color: #929292;
}
.arrowright {
  margin-left: 3px;
  width: 5px;
  height: 10px;
}
.t2 {
  color: black;
  font-size: 14px;
  text-align: left;
  margin-left: 10px;
  margin-top: 10px;
}
.t3 {
  color: black;
  font-size: 18px;
  font-weight: bold;
  margin-left: 10px;
}
.t4 {
  color: black;
  font-size: 12px;
  text-align: center;
  line-height: 40px;
}
.t5 {
  color: #dc9712;
  font-size: 14px;
  margin-left: 10px;
  text-align: left;
  margin-top: 6px;
  margin-bottom: 10px;
}
.line {
  margin-left: 10px;
  margin-right: 10px;
  height: 1px;
  background-color: #dfdfdf;
}

>>> .van-cell {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  box-sizing: border-box;
  width: 100%;
  padding: 10px 5px;
  overflow: hidden;
  color: #323233;
  font-size: 14px;
  line-height: 24px;
  background-color: #fff;
}

.btn {
  width: 100%;
  height: 30px;
}
</style>